// LiveStreamPusherHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

import { ExclusivePrivateStatus as ExclusivePrivateStatusConstant } from '../resource/liveStreamConstants.js';

export class LiveStreamPusherHandler extends React.PureComponent {
  canSubscribePresenceStreamExclusive = () => {
    const {
      meId,
      exclusivePrivateStatus,
      exclusivePrivateBuyerId,
      isLivestreamModerator,
    } = this.props;
    const isExclusivePrivateBuyer =
      meId != null && meId === exclusivePrivateBuyerId;
    return (
      ExclusivePrivateStatusConstant.PERFORMING === exclusivePrivateStatus &&
      (isExclusivePrivateBuyer || isLivestreamModerator)
    );
  };
  componentDidMount() {
    const {
      streamId,
      subscribeStreamChannel,
      shouldSubscribeStreamChannel,
      subscribePresenceStreamExclusive,
    } = this.props;
    if (this.canSubscribePresenceStreamExclusive()) {
      subscribePresenceStreamExclusive({
        streamId,
      });
    }
    if (shouldSubscribeStreamChannel) {
      subscribeStreamChannel({
        streamId,
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      streamId,
      meId,
      shouldSubscribeStreamChannel,
      unsubscribeStreamChannel,
      exclusivePrivateStatus,
      exclusivePrivateBuyerId,
      isLivestreamModerator,
      subscribePresenceStreamExclusive,
      unsubscribePresenceStreamExclusive,
    } = this.props;
    if (
      meId !== prevProps.meId ||
      exclusivePrivateBuyerId !== prevProps.exclusivePrivateBuyerId ||
      isLivestreamModerator !== prevProps.isLivestreamModerator ||
      exclusivePrivateStatus !== prevProps.exclusivePrivateStatus
    ) {
      if (this.canSubscribePresenceStreamExclusive()) {
        subscribePresenceStreamExclusive({
          streamId,
        });
      } else {
        unsubscribePresenceStreamExclusive({
          streamId,
        });
      }
    }
    if (
      !shouldSubscribeStreamChannel &&
      shouldSubscribeStreamChannel !== prevProps.shouldSubscribeStreamChannel
    ) {
      unsubscribeStreamChannel({ streamId });
    }
  }
  componentWillUnmount() {
    const {
      streamId,
      unsubscribeStreamChannel,
      unsubscribePresenceStreamExclusive,
    } = this.props;
    unsubscribePresenceStreamExclusive({
      streamId,
    });
    unsubscribeStreamChannel({
      streamId,
    });
  }
  render() {
    return null;
  }
}

LiveStreamPusherHandler.propTypes = {
  streamId: PropTypes.string,
  meId: PropTypes.string,
  subscribeStreamChannel: PropTypes.func,
  unsubscribeStreamChannel: PropTypes.func,
  subscribePresenceStreamExclusive: PropTypes.func,
  unsubscribePresenceStreamExclusive: PropTypes.func,
  shouldSubscribeStreamChannel: PropTypes.bool,
  exclusivePrivateStatus: PropTypes.string,
  exclusivePrivateBuyerId: PropTypes.string,
  isLivestreamModerator: PropTypes.bool,
};

LiveStreamPusherHandler.defaultProps = {
  streamId: null,
  meId: null,
  subscribeStreamChannel: () => null,
  unsubscribeStreamChannel: () => null,
  subscribePresenceStreamExclusive: () => null,
  unsubscribePresenceStreamExclusive: () => null,
  shouldSubscribeStreamChannel: true,
  exclusivePrivateStatus: null,
  exclusivePrivateBuyerId: null,
  isLivestreamModerator: false,
};

export default LiveStreamPusherHandler;
